import { mutatorAction } from 'satcheljs';
import { getItem, setItem } from 'owa-local-storage';
import { getStore } from '../store/Store';
import getValidFavoritesPaneHeight from '../utils/getValidFavoritesPaneHeight';

const FAVORITES_PANE_HEIGHT_STORAGE_KEY = 'FavoritesPaneHeight';

/**
 * Sets the height the pinned Favorites section
 * @param value The height to set, or null/undefined to clear the height
 */
export const setFavoritesPaneHeightValueMutator: (value: number | null | undefined) => void =
    mutatorAction(
        'setFavoritesPaneHeightValueMutator',
        (value: number | null | undefined): void => {
            const validHeight = getValidFavoritesPaneHeight(value);
            if (validHeight) {
                getStore().favoritesPaneHeight = validHeight;
                setItem(window, FAVORITES_PANE_HEIGHT_STORAGE_KEY, String(validHeight));
            }
        }
    );

/**
 * Initializes the store from the localStorage value if available
 */
export const initializeFavoritesPaneHeightMutator: () => void = mutatorAction(
    'initializeFavoritesPaneHeightMutator',
    (): void => {
        const height = getItem(window, FAVORITES_PANE_HEIGHT_STORAGE_KEY);
        const parsed = height != null ? Number(height) : undefined;
        getStore().favoritesPaneHeight = getValidFavoritesPaneHeight(parsed);
    }
);
